
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"location","fill":"#bac1cc"}},[_c('path',{attrs:{"d":"M12 14.18a3.87 3.87 0 113.87-3.87A3.874 3.874 0 0112 14.18zm0-6.24a2.37 2.37 0 102.37 2.37A2.373 2.373 0 0012 7.94z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.997 1.25a9.749 9.749 0 015.649 1.766 8.815 8.815 0 013.466 5.319 11.06 11.06 0 01-.977 7.421 19.047 19.047 0 01-4.015 5.326 5.943 5.943 0 01-8.249 0 19.087 19.087 0 01-4.007-5.332 11.083 11.083 0 01-.976-7.426 8.815 8.815 0 013.467-5.311 9.744 9.744 0 015.642-1.763zm0 20a4.414 4.414 0 003.08-1.25c2.675-2.568 5.637-6.618 4.569-11.335a7.56 7.56 0 00-7.649-5.915 7.559 7.559 0 00-7.646 5.906C3.284 13.371 6.241 17.428 8.91 20a4.44 4.44 0 003.089 1.245z"}})])])
          )
        }
      }
    